import PublicCollection from "../lib/util/public-collection";

class CommonsService {
	collection = new PublicCollection('commons');

	async getIndex(query, after, pageSize) {
		return this.collection.getIndex(query, after, pageSize);
	}

	async get(id) {
		return this.collection.get(id);
	}
}

export default new CommonsService();